(function($) {
    $(".tab__title").on("click", function() {
        $(this).parent().toggleClass("tab-active").find('.slick-slider').slick('setPosition');
    })
})(jQuery); 